import React, { useRef } from "react";
import { useVirtualizer } from "@tanstack/react-virtual";

const ROW_HEIGHT = 32;

export const VirtualizedWcTable = React.memo(function VirtualizedWcTable({ 
  data, 
}) {
  const parentRef = useRef(null);

  const rowVirtualizer = useVirtualizer({
    count: data.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => ROW_HEIGHT,
    overscan: 15,
  });

  const virtualItems = rowVirtualizer.getVirtualItems();

  if (data.length === 0) {
    return (
      <div className="p-8 text-center text-slate-500" data-testid="virtualized-wc-table">
        No WC rates found
      </div>
    );
  }

  return (
    <div data-testid="virtualized-wc-table">
      {/* Header row */}
      <div className="grid grid-cols-8 bg-slate-50 border-b border-slate-200 text-xs font-semibold text-slate-500 uppercase tracking-wider">
        <div className="px-4 py-2.5">State</div>
        <div className="px-4 py-2.5">Code</div>
        <div className="px-4 py-2.5 col-span-2">Description</div>
        <div className="px-4 py-2.5 text-right">Bill Rate</div>
        <div className="px-4 py-2.5 text-right">Cost Rate</div>
        <div className="px-4 py-2.5 text-right">Modifier</div>
        <div className="px-4 py-2.5">Risk/Policy</div>
      </div>
      
      {/* Scrollable body */}
      <div 
        ref={parentRef} 
        className="overflow-auto"
        style={{ height: '384px' }}
      >
        <div
          style={{
            height: `${rowVirtualizer.getTotalSize()}px`,
            width: '100%',
            position: 'relative',
          }}
        >
          {virtualItems.map((virtualRow) => {
            const r = data[virtualRow.index];
            if (!r) return null;
            return (
              <div 
                key={virtualRow.key} 
                data-index={virtualRow.index}
                className="grid grid-cols-8 border-b border-slate-100 hover:bg-slate-50/50 text-xs"
                style={{ 
                  height: `${ROW_HEIGHT}px`,
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  transform: `translateY(${virtualRow.start}px)`,
                }}
              >
                <div className="px-4 py-1.5 font-medium text-slate-900">{r.state}</div>
                <div className="px-4 py-1.5 font-mono">{r.classCode}</div>
                <div className="px-4 py-1.5 text-slate-600 col-span-2 truncate" title={r.description}>
                  {r.description}
                </div>
                <div className="px-4 py-1.5 text-right font-mono">{r.billRate}%</div>
                <div className="px-4 py-1.5 text-right font-mono">{r.costRate}%</div>
                <div className="px-4 py-1.5 text-right font-mono">{r.modifier}</div>
                <div className="px-4 py-1.5 text-slate-600">{r.risk} {r.policyType && `/ ${r.policyType}`}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default VirtualizedWcTable;
